import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import styled from 'styled-components';
import noop from 'lodash/noop';
import { space, font } from 'nicollet-tokens';
import { Option } from './Option.js';
import { OptionLink } from './OptionLink.js';
import { OptionLabel } from './OptionLabel.js';
import { Checkmark } from './Checkmark.js';
import { StyledImage } from './styles.js';

const OptionDescriptor = styled.div`
  flex: 60px;
  margin-right: ${space.generic.x3};
  font-size: ${font.size.text.small};
`;
const DisabledOptionWrapper = styled.div`
  padding-top: ${space.generic.x3};
  padding-bottom: ${space.generic.x3};

  cursor: default;
`;

const getOptionLinkAriaLabel = (label = '', descriptor = '', selected = false) => {
  const descriptorLabel = descriptor ? ` - ${descriptor}` : '';
  const selectedLabel = selected ? ' - selected' : '';
  return `${label}${descriptorLabel}${selectedLabel}`;
}; // TODO: fix eslint rule react/no-unsafe https://git.target.com/design-systems/nicollet/issues/1315

/* eslint-disable react/no-unsafe */
// eslint-disable-next-line react/display-name


class OptionItem extends Component {
  constructor(props) {
    super(props);
    const {
      selected = false
    } = props.data;
    this.state = {
      selected
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
  }
  /**
   * On subsequent updates after first mount
   * Options will not update unless updated in state.
   */

  /* eslint-disable-next-line camelcase */


  UNSAFE_componentWillReceiveProps(nextProps) {
    let {
      selected
    } = nextProps.data;

    if (!selected) {
      selected = false;
    }

    this.setState({
      selected
    });
  }
  /**
   * lets the event bubble up.
   * Does not allow un-select already selected values,
   * only triggers on change of select, like the
   * native select box does.
   * @param {Object} event DOM click event
   */


  handleSelect(event) {
    const targetType = event.target.type;

    if (targetType !== 'checkbox') {
      event.preventDefault();
    }

    const {
      data,
      onChange = noop
    } = this.props;
    let {
      selected
    } = this.state;

    if (!selected) {
      selected = !selected;
    }

    this.setState({
      selected
    });
    onChange(event, data);
  }
  /**
   * lets the event bubble up.
   * Does allow un-select already selected values.
   * Triggers OnChange when a value is selected or unselected
   * @param {Object} event DOM click event
   */


  handleMultiSelect(event) {
    const targetType = event.target.type;

    if (targetType !== 'checkbox') {
      event.preventDefault();
    }

    const {
      label = '',
      value
    } = this.props.data;
    const {
      onChange = noop
    } = this.props;
    const selected = !this.state.selected;
    this.setState(prevState => ({
      selected: !prevState.selected
    }));
    onChange(event, {
      label,
      value,
      selected
    });
  }

  renderOptionContent() {
    const {
      selected
    } = this.state;
    const {
      data,
      disabled
    } = this.props;
    const {
      label,
      imageUrl,
      descriptor,
      hasStrikethrough
    } = data;
    return jsxs(Option, Object.assign({
      disabled: disabled,
      middle: "xs",
      selected: selected,
      wrap: "nowrap"
    }, {
      children: [imageUrl && jsx("div", {
        children: jsx(StyledImage, {
          "aria-hidden": true,
          "data-test": `OptionItemImage-${label}`,
          src: imageUrl
        }, void 0)
      }, void 0), jsx(OptionLabel, Object.assign({
        disabled: disabled,
        hasStrikethrough: hasStrikethrough
      }, {
        children: label
      }), void 0), descriptor && jsx(OptionDescriptor, {
        children: jsx("span", Object.assign({
          "data-test": `OptionItemDescriptor-${label}`
        }, {
          children: descriptor
        }), void 0)
      }, void 0), selected && jsx(Checkmark, {}, void 0)]
    }), void 0);
  }

  render() {
    const {
      selected
    } = this.state;
    const {
      multiSelect,
      childRef,
      data,
      disabled
    } = this.props;
    const {
      label,
      descriptor
    } = data;
    const optionContent = this.renderOptionContent();
    return disabled ? jsx(DisabledOptionWrapper, Object.assign({
      "data-test": "disabled-option-item"
    }, {
      children: optionContent
    }), void 0) : jsx(OptionLink, Object.assign({
      "aria-label": getOptionLinkAriaLabel(label, descriptor, selected),
      href: "#",
      // TODO: these two methods are onChange handlers, but being passed into an onClick
      // @ts-ignore
      onClick: multiSelect ? this.handleMultiSelect : this.handleSelect,
      ref: childRef
    }, {
      children: optionContent
    }), void 0);
  }

}
OptionItem.defaultProps = {
  data: {
    selected: false
  }
};

export { OptionItem };
